export const listingUpdateSuccess = 'Successfully updated ';
export const autoplayOn = 'Autoplay has been turned on';
export const autoplayOff = 'Autoplay has been turned off';
export const successUpdateSong = 'Successfully updated song selection!';
export const updateSongChoice = 'Updated song choice: ';
export const addedSongSuccess = 'Added song to your virtual tour!';
export const analyticsWarning = '*events can take up to an hour to appear in our analytics';
export const vtTitle = 'Virtual tour';
export const copyLink = 'Copied virtual tour link to your clipboard!';
export const vtButton = 'view virtual tour';
export const addMusicButton = 'select a song';
export const learnMoreSpan = 'learn more';
export const learnMoreText = ' about why we recommend keeping autoplay disabled';
export const unMute = 'un-mute';
export const mute = 'mute';
export const selectSongTitle = 'Select a song for your virtual tour.';
export const selectSongButton = 'done';
export const musicLabel = 'Add a song to virtual tour slideshow';
